export type AnyObject<
  ValueDataType,
  KeyDataType extends string | number | symbol = string,
> = Record<KeyDataType, ValueDataType>;

// TODO: Use primeng type MenuItem and extend with `class` prop
export type MenuTabItems = {
  tabLabel: string;
  navUrl: string;
  visible?: boolean;
  class?: string;
};

export type DropDownOptions = {
  id: number;
  label: string;
};

export type DropDownNameOptions = {
  id: number;
  name: string;
};

export type PolarOptions = {
  label: string;
  value: string | boolean | number;
};

export const YesNoOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

type MetricsData = {
  name: string;
  count: number;
  colorId: number;
};

export type WidgetItem = {
  metrics: MetricsData[];
  title: string;
  class: string;
};

export type Site = {
  id: number;
  name: string;
  code: string;
  stateCode: string;
};

export enum LocalStorageKeys {
  CURRENT_TENANT_ID = 'currentTenantId',
  SIDEBAR_PREFERENCE = 'sidebarPreference',
}

export type AccordionStateValue = {
  value: boolean;
  // eslint-disable-next-line no-use-before-define
  children?: AccordionState;
};

export type AccordionState = AnyObject<
  AccordionStateValue | AccordionStateValue[],
  string
>;

export type ChangeLog = {
  fieldName: string;
  oldValue: string;
  newValue: string;
  updatedDate: string;
  updatedBy: string;
  description: string;
};
